/* tslint:disable */

declare var Object: any;
export interface SFBusinesstripReportInterface {
  "id"?: number;
}

export class SFBusinesstripReport implements SFBusinesstripReportInterface {
  "id": number;
  constructor(data?: SFBusinesstripReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFBusinesstripReport`.
   */
  public static getModelName() {
    return "SFBusinesstripReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFBusinesstripReport for dynamic purposes.
  **/
  public static factory(data: SFBusinesstripReportInterface): SFBusinesstripReport{
    return new SFBusinesstripReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFBusinesstripReport',
      plural: 'SFBusinesstripReports',
      path: 'SFBusinesstripReports',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFBusinesstripReport.ts